import React, { Fragment } from 'react';
import './Contact.css';
import MaskedInput from 'react-maskedinput'
import { postMessageContact } from '../../services/Contact';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from '../../components/Modal';
import ModalContentMessage from '../ModalContentMessage';
import { Creators as LoaderActions } from '../../store/ducks/loader';

 class Contact extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            openModal:false,
            name: '',
            lastName: '',
            email: '',
            celPhone: '',
            phone: '',
            operator: '',
            message: ''
        }
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleClearForm = this.handleClearForm.bind(this);
    }

    async handleFormSubmit(e) {
        e.preventDefault();
        const { isLoading } = this.props;
        isLoading(true);
        const { name, lastName, email, phone, celPhone, operator
            , message } = this.state;
        const data = { name, lastName, email, phone, celPhone, operator,
        message };
        try {
        await postMessageContact(data);
        this.handleClearForm();
        } catch (Error) {
         alert('Error');
        }

        this.setState({openModal:true});
        isLoading(false);
    }

    handleCloseModal(){
        this.setState({openModal:false});
    }

    handleClearForm(){
        console.log('entrou');
        this.setState({
            name:'',
            lastName:'',
            email:'',
            celPhone:'',
            phone:'',
            operator:'',
            message:''
        });
    }

    render() {

        const { name, lastName, email, celPhone, phone, operator, message } = this.state;
        const { openModal } = this.state;
        return (
            <Fragment>
                <div id="Contact" className="container contact">
                    <h3 className="mt-5 contact__title">CONTATO</h3>
                    <h4 className="contact-title-two title-two text-color">Caso tenha alguma dúvida é só preencher os campos abaixo
                        e aguardar nosso contato
                </h4>
                    <div className="container">
                        <form onSubmit={this.handleFormSubmit} >
                            <div className="row">
                                <div className="col-xl-6">
                                    <div className="form-group">
                                        <label className="contact-label" htmlFor="nome">NOME</label>
                                        <input
                                            required
                                            value={name}
                                            type="text"
                                            className="form-control contact-input"
                                            id="nome"
                                            onChange={(e) => this.setState({ name: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className=" col-xl-6">
                                    <div className="form-group">
                                        <label className="contact-label" htmlFor="sobrenome">SOBRENOME</label>
                                        <input
                                            required
                                            value={lastName}
                                            className="form-control contact-input"
                                            id="sobrenome"
                                            onChange={(e) => this.setState({ lastName: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="form-group">
                                        <label className="contact-label" htmlFor="email">EMAIL</label>
                                        <input
                                            required
                                            value={email}
                                            type="email"
                                            className="form-control contact-input"
                                            id="email"
                                            onChange={(e) => this.setState({ email: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-6">
                                    <div className="form-group">
                                        <label className="contact-label" htmlFor="celular">CELULAR</label>
                                        <MaskedInput
                                            required
                                            mask="(11) 1 1111-1111"
                                            value={celPhone}
                                            className="form-control contact-input"
                                            id="celular"
                                            onChange={(e) => this.setState({ celPhone: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className=" col-xl-6">
                                    <div className="form-group">
                                        <label className="contact-label" htmlFor="operadora">OPERADORA</label>
                                        <select
                                            required
                                            value={operator}
                                            className="form-control contact-input"
                                            id="operadora"
                                            onChange={(e) => this.setState({ operator: e.target.value })}
                                        >
                                            <option value="tim">TIM</option>
                                            <option value="oi">OI</option>
                                            <option value="vivo">VIVO</option>
                                            <option value="claro">CLARO</option>
                                            <option value="Outra">OUTRA</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="form-group">
                                        <label className="contact-label" htmlFor="telefone">TELEFONE</label>
                                        <MaskedInput
                                            mask="(11) 1 1111-1111"
                                            value={phone}
                                            className="form-control contact-input"
                                            id="telefone"
                                            onChange={(e) => this.setState({ phone: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="form-group">
                                        <label className="contact-label" htmlFor="message">MENSAGEM</label>
                                        <textarea
                                            required
                                            value={message}
                                            className="form-control contact-textarea"
                                            id="titulo"
                                            onChange={(e) => this.setState({ message: e.target.value })}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <button className="contact-push" type="submit">Enviar</button>
                            </div>
                        </form>
                    </div>
                </div>
                <Modal
                    open={openModal}
                    onClose={this.handleCloseModal}>
                     <ModalContentMessage
                        message="Mensagem Enviado com sucesso!"
                        onCLickButton={this.handleCloseModal} />
                </Modal>
            </Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => bindActionCreators(LoaderActions, dispatch);

const mapStateToProps = state => ({
    loader: state.loader
  });

export default connect(mapStateToProps,mapDispatchToProps)(Contact);



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js